export class SharedPushCapabilitiesHelper {

    static get isServiceWorkerSupported(): boolean {
        try {
            return typeof navigator !== 'undefined'
                && 'serviceWorker' in navigator;
        } catch {
            return false;
        }
    }

    static get isNotificationSupported(): boolean {
        try {
            return typeof Notification !== 'undefined'
                && typeof Notification.requestPermission === 'function';
        } catch {
            return false;
        }
    }

    static get isPushManagerSupported(): boolean {
        try {
            return typeof window !== 'undefined'
                && 'PushManager' in window;
        } catch {
            return false;
        }
    }

    static get isSecureContext(): boolean {
        try {
            return typeof window !== 'undefined'
                && window.isSecureContext === true;
        } catch {
            return false;
        }
    }

    static get isPushApiFullySupported(): boolean {
        return (
            this.isSecureContext &&
            this.isNotificationSupported &&
            this.isServiceWorkerSupported &&
            this.isPushManagerSupported
        );
    }

    static get isIOS(): boolean {
        try {
            const ua = navigator.userAgent;
            const isIOSDevice = /iPad|iPhone|iPod/.test(ua);
            const isIPadOS13Plus = ua.includes("Macintosh") && "ontouchend" in document;
            return isIOSDevice || isIPadOS13Plus;
        } catch {
            return false;
        }
    }

    static get isIOSOld(): boolean {
        if (!this.isIOS) return false;
        return !this.isPushApiFullySupported;
    }

    static get isPushSupportedOnThisDevice(): boolean {
        return (
            !this.isIOSOld &&       // exclude iOS <16.4
            this.isPushApiFullySupported
        );
    }
}